import { newRequestKey } from '../../../components/messaging/requestKey';
const slot = (actor, id) => `uzdpart360:business-resolution:${actor}:${id}`;
export function loadResolutionRequest(actor, id) {
  const raw = localStorage.getItem(slot(actor, id));
  if (raw === null) return null;
  let saved; try { saved = JSON.parse(raw); } catch { throw new Error('Saved resolution request is unreadable. Do not create another key.'); }
  const body = saved?.body, verification = body?.verification;
  if (saved?.id !== id || String(saved.actor) !== String(actor) || typeof saved.key !== 'string' || !saved.key.trim() || saved.key.length > 128
    || !body || Object.keys(body).some(key => !['expected_status', 'expected_updated_at', 'resolution', 'verification'].includes(key))
    || !['processing', 'reconciliation_required'].includes(body.expected_status) || !Number.isFinite(Date.parse(body.expected_updated_at))
    || !['delivered', 'not_delivered'].includes(body.resolution) || !verification || Object.keys(verification).some(key => !['method', 'confirmed', 'checked_at', 'message_id'].includes(key))
    || !['provider_history', 'recipient_confirmation'].includes(verification.method) || verification.confirmed !== true || !Number.isFinite(Date.parse(verification.checked_at))) throw new Error('Saved resolution request is invalid. Do not create another key.');
  return saved;
}
export function freezeResolutionRequest(actor, row, values) {
  const existing = loadResolutionRequest(actor, row.operation_id);
  if (existing) return existing;
  const request = { actor, id: row.operation_id, key: newRequestKey(), body: {
    expected_status: row.status, expected_updated_at: row.updated_at, resolution: values.resolution,
    verification: { method: values.method, confirmed: values.confirmed === true, checked_at: values.checked_at, message_id: values.message_id || null },
  } };
  const encoded = JSON.stringify(request); localStorage.setItem(slot(actor, row.operation_id), encoded);
  if (localStorage.getItem(slot(actor, row.operation_id)) !== encoded) throw new Error('Resolution request could not be saved. Nothing was submitted.');
  return request;
}
export const clearResolutionRequest = (actor, id) => localStorage.removeItem(slot(actor, id));
export function pendingResolutionIds(actor) {
  const ids = [];
  try {
    const prefix = `uzdpart360:business-resolution:${actor}:`;
    for (let index = 0; index < localStorage.length; index += 1) {
      const key = localStorage.key(index);
      if (!key?.startsWith(prefix)) continue;
      const id = key.slice(prefix.length);
      try { if (/^op_[a-f0-9]{32}$/.test(id) && loadResolutionRequest(actor, id)) ids.push(id); } catch { /* Never replace an unreadable pending key. */ }
    }
  } catch { /* Storage unavailable: leave all fences intact. */ }
  return ids;
}
